enum PasswordRequirementsEnum {
	EXACT_LENGTH = 'EXACT_LENGTH',
	HAS_LOWERCASE = 'HAS_LOWERCASE',
	HAS_NUMBER = 'HAS_NUMBER',
	HAS_UPPERCASE = 'HAS_UPPERCASE',
	HAS_SPECIAL_CHAR = 'HAS_SPECIAL_CHAR',
	MATCH_PASSWORDS = 'MATCH_PASSWORDS',
	MATCH_EMAIL = 'MATCH_EMAIL',
	MATCH_CELLPHONE = 'MATCH_CELLPHONE',
}

export const PASSWORD_REQUIREMENTS: Record<PasswordRequirementsEnum, string> = {
	EXACT_LENGTH: 'Exatamente 6 caracteres',
	HAS_LOWERCASE: '1 letra minúscula',
	HAS_NUMBER: '1 número',
	HAS_UPPERCASE: '1 letra maiúscula',
	HAS_SPECIAL_CHAR: '1 caractere especial (Ex.: @, #, !, %)',
	MATCH_PASSWORDS: 'As senhas informadas não são iguais',
	MATCH_EMAIL: 'Os e-mails informados não são iguais',
	MATCH_CELLPHONE: 'Os números informados não são iguais',
};
